import { ApiBaseService } from './api-base.service';
import { AppGlobals } from '../app.globals';
import { SafeUrl } from '@angular/platform-browser';
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { currentBrand } from '../helpers/tenant-switch';
import { LogoResponse } from '../interfaces/entities/logos';
import { ApiFileService } from './api-file.service';

@Injectable({
  providedIn: 'root',
})
export class LogoService {
  get defaultLargeLogo(): string {
    const brandFolder = this.getBrandFolderFromDomain();
    return `/assets/images/branding/${brandFolder}/logo.png`;
  }

  get defaultSmallLogo(): string {
    const brandFolder = this.getBrandFolderFromDomain();
    return `/assets/images/branding/${brandFolder}/logo-small.png`;
  }

  get defaultFavicon(): string {
    const brandFolder = this.getBrandFolderFromDomain();
    return `/assets/images/branding/${brandFolder}/favicon.ico`;
  }

  private getBrandFolderFromDomain(): string {
    return currentBrand();
  }

  eventEmitter = new ReplaySubject<{ smallLogo?: SafeUrl; largeLogo?: SafeUrl; favicon?: SafeUrl }>(1);

  constructor(
    private apiService: ApiBaseService,
    private apiFileService: ApiFileService
  ) { }

  async GetLogos(): Promise<LogoResponse> {
    const result = await this.apiService.httpGETRequest('LogoService/GetLogos', {}, true, 'json');
    if (result.hasError) {
      AppGlobals.ShowErrorMessage(result.feedback);
      return;
    }

    await this.convertLogos(result);
    return result;
  }

  async SaveLogo(logoData: string, logoType: 'large' | 'small'): Promise<LogoResponse> {
    const result = await this.apiService.httpRequest(
      'LogoService/SaveLogo',
      { logoData: logoData, logoType: logoType },
      true,
      true
    );

    if (result.hasError) {
      AppGlobals.ShowErrorMessage(result.feedback);
      return;
    }

    await this.convertLogos(result, false);
    return result;
  }

  async DeleteLogo(logoType: string): Promise<LogoResponse> {
    const result = await this.apiService.httpRequest('LogoService/DeleteLogo', { logoType }, true, true);
    if (result.hasError) {
      AppGlobals.ShowErrorMessage(result.feedback);
      return;
    }

    await this.convertLogos(result, false);
    return result;
  }

  async convertLogos(result: LogoResponse, setToDefault: boolean = true) {
    if (!result || !result.logos) return;

    const logos = result.logos;
    const [small, large, favicon] = await Promise.all([
      this.apiFileService.logoUrl('small', logos.smallLogoVersion),
      this.apiFileService.logoUrl('large', logos.largeLogoVersion),
      this.apiFileService.logoUrl('favicon', logos.faviconVersion),
    ]);

    logos.smallLogo = small ?? (setToDefault ? this.defaultSmallLogo : null);
    logos.largeLogo = large ?? (setToDefault ? this.defaultLargeLogo : null);
    logos.favicon = favicon ?? (setToDefault ? this.defaultFavicon : null);
  }
}
